<form [formGroup]="form" (keydown.enter)="$event.preventDefault()" (ngSubmit)="onSubmit()">
  <!-- Question Properties -->
  <div class="metadata-block">
    <div class="metadata-property">
      <div class="metadata-key">Label</div>
      <input class="metadata-input" fxFlexFill formControlName="label" placeholder="label">
    </div>
    <div class="metadata-property">
      <div class="metadata-key">Description</div>
      <input class="metadata-input" fxFlexFill formControlName="description" placeholder="description">
    </div>
    <div class="metadata-property">
      <div class="metadata-key">Namespace</div>
      <input class="metadata-input" fxFlexFill formControlName="namespace" placeholder="namespace">
    </div>
    <div class="metadata-property">
      <div class="metadata-key">TypeId</div>
      <input class="metadata-input" fxFlexFill formControlName="typeId" placeholder="TypeId" type="number">
    </div>    
  </div>
  <div class="metadata-block">
    <div class="metadata-property">
      <div class="metadata-key">Tags</div>
      <div class="question-input">
        <input class="metadata-input" #input fxFlexFill maxlength="50" placeholder="Tags" (keyup.enter)="addTags($event)">        
        <div class="tag-row">
          <div *ngFor="let tag of tags" class="tags">
            <div fxFlexFill placeholder="Tags" class="tag-value">{{tag}}
            <button type="button" class="btn-close" (click)="removeTags(tag)" aria-label="Close">x</button>
            </div>          
          </div>
        </div>
        <!--</mat-form-field>-->
      </div>      
    </div>
  </div>
  <div *ngIf="isEdit">
    <div class="modal-footer">
      <button type="button" (click)="notifyParent.emit('close')" class="btn btn-default reject-button">Cancel</button>
      <button type="submit" [disabled]="!form.valid" class="btn btn-primary">Save Question</button>
    </div>
  </div>
</form>
